import React from 'react';

const Carousel = () => {
  return (
    <div className="home-banner">
  <div id="c1" className="carousel slide carousel-fade">
    <div className="carousel-inner">
      <div className="carousel-item active">
        <div className="carousel-item-0">
          <i
            className="bg-1"
            style={{ backgroundImage: "url(assets/img/bg-1.png)" }}
          />
          <i className="glow-1" />
          <div className="container position-relative">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center text-white">
                <h2 className="top-head">
                  From Spray-and-Pray to Empathetic Engagement.
                </h2>
                <h5 className="top-desc">
                  Learn more about our <b>Human-centric, Data-driven</b>{" "}
                  marketing
                </h5>
                <a href="#" className="lm me-2 me-md-4">
                  Learn More
                </a>
                <a href="#" className="sh-meeting">
                  Schedule a Meeting?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="carousel-item">
        <div className="carousel-item-0">
          <i
            className="bg-1"
            style={{ backgroundImage: "url(assets/img/bg-2.png)" }}
          />
          <i className="glow-1" />
          <div className="container position-relative">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center text-white">
                <h2 className="top-head">Don’t panic. It’s organic.</h2>
                <h5 className="top-desc">
                  Learn more about our <b>Search Engine Optimization</b>{" "}
                  services.
                </h5>
                <a href="#" className="lm me-2 me-md-4">
                  Learn More
                </a>
                <a href="#" className="sh-meeting">
                  Schedule a Meeting?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="carousel-item">
        <div className="carousel-item-0">
          <i
            className="bg-1"
            style={{ backgroundImage: "url(assets/img/bg-3.png)" }}
          />
          <i className="glow-1" />
          <div className="container position-relative">
            <div className="row justify-content-center">
              <div className="col-lg-7 text-center text-white">
                <h2 className="top-head">
                  We’ll craft the storytelling. So you can focus on selling.
                </h2>
                <h5 className="top-desc">
                  Learn more about our <b>Content Marketing</b> services.
                </h5>
                <a href="#" className="lm me-2 me-md-4">
                  Learn More
                </a>
                <a href="#" className="sh-meeting">
                  Schedule a Meeting?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="carousel-item">
        <div className="carousel-item-0">
          <i
            className="bg-1"
            style={{ backgroundImage: "url(assets/img/bg-4.png)" }}
          />
          <i className="glow-1" />
          <div className="container position-relative">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center text-white">
                <h2 className="top-head">Every pixel with a purpose.</h2>
                <h5 className="top-desc">
                  Learn more about our <b>Full services B2B marketing</b>{" "}
                  services.
                </h5>
                <a href="#" className="lm me-2 me-md-4">
                  Learn More
                </a>
                <a href="#" className="sh-meeting">
                  Schedule a Meeting?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="c1-carousel-control">
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#c1"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#c1"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
  <div className="text-center brands-helped text-white">
    <div className="container">
      <h3 className="another-tp">BRANDS WE'VE HELPED</h3>
      <div className="row justify-content-center">
        <div className="col-xxl-10">
          <div className="owl-carousel owl-c text-center">
            <div className="item">
              <img src="assets/img/clients/akraya.svg" alt="akraya" />
            </div>
            <div className="item">
              <img src="assets/img/clients/beeline.svg" alt="beeline" />
            </div>
            <div className="item">
              <img
                src="assets/img/clients/dyn-sys-logo.svg"
                alt="dynamic systems"
              />
            </div>
            <div className="item">
              <img src="assets/img/clients/exl.svg" alt="exl" />
            </div>
            <div className="item">
              <img src="assets/img/clients/iqvia.svg" alt="iqvia" />
            </div>
            <div className="item">
              <img src="assets/img/clients/mareana.svg" alt="mareana" />
            </div>
            <div className="item">
              <img src="assets/img/clients/nttdata.svg" alt="nttdata" />
            </div>
            <div className="item">
              <img src="assets/img/clients/ropaar.png" alt="ropaar" />
            </div>
            <div className="item">
              <img src="assets/img/clients/xoriant.png" alt="xoriant" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  );
};

export default Carousel;
